import { useEffect, useRef } from "react";
import useAuth from "../../hooks/useAuth";
import { baseURL, handleNotOkHttpResponse } from "../../utils/misc";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isSinglePageActive } from "../../utils/daynamicNavigation";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Preloader from "../common/Preloader";
import { getFarmAreaUnit, getFarmerFullName, getFullBuyerName, getUserFullName, isoToDate } from "../../utils/helpers";
import { getFarmerById } from "../../api/Farmer/getFarmerById";
import { CompanyIds, runningCompanyId } from "../../appSetup";

function FarmTable({ farmerId }) {
    const { user } = useAuth();
    const [farms, setFarms] = useState([]);
    const navigate = useNavigate();
    const [showPreloader, setShowPreloader] = useState(false);
    const [show, setShow] = useState(false);
    const [selectRecordId, setSelectedRecordId] = useState(null);
    const [farmer, setFarmer] = useState();

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const profileMenuItems = [
        {
            id: 1,
            name: "View",
            icon: "icon-eye1",
            onClick: (process) => {
                handleShowViewModal(process);
            },
        },
        {
            id: 2,
            name: "Edit",
            icon: "icon-edit1",
            routerPath: "/farm/edit",
        },
        {
            id: 3,
            name: "Delete",
            icon: "icon-delete",
            onClick: (process) => {
                handleShowDeleteModal(process);
            },
            authType: 'admin',
        },
        {
            id: 4,
            name: "Fields",
            icon: "icon-area-graph",
            routerPath: "/fields/farm",
        },
        // {
        //     id: 3,
        //     name: "Delete",
        //     icon: "flaticon-transfer-1",
        //     onClick: (process) => {
        //         handleShow(process.id)
        //     },
        // }
    ];

    // Define the path pattern for user profiles
    const $ = require("jquery");

    useEffect(() => {
        setShowPreloader(true);
        getFarmerById(farmerId, user.user.token).then(m => { setFarmer(m); });
        setShowPreloader(false);
    });

    useEffect(() => {
        if (farms && farms.length > 0) {
            //Initialize DataTable when users are available
            $(document).ready(function () {
                const dataTable = $("#data-table").DataTable();

                // Destroy DataTable if it exists
                if (dataTable) {
                    dataTable.destroy();
                }

                $("#data-table").DataTable({
                    // Add any required DataTable options here
                    columnDefs: [
                        { width: "10%", targets: 0 },
                        { width: "12%", targets: 2 }
                    ]
                });
            });
        }
    }, [farms, $]);


    useEffect(() => {
        const fetchFarms = async () => {
            if (!(user && user.user.token)) {
                navigate('/login');
                toast.warn("You seem to have lost your access token. Please try again later.");
                return;
            }
            setShowPreloader(true);
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user.user.token}`,
                    }
                };
                const response = await fetch(`${baseURL}/farms/farmer/${farmerId}`, requestOptions);
                if (!response.ok) {
                    throw new Error('Error fetching farms');
                }
                const data = await response.json();
                setFarms(data);
            } catch (error) {
                toast.error("Error fetching farms.");
                console.error("Error fetching farms:", error);
            } finally {
                setShowPreloader(false);
            }
        };
        fetchFarms();
    }, []);

    const handleShowViewModal = (record) => {
        setSelectedRecord(record);
        setShowViewModal(true);
    };

    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedRecord(null);
    };

    const handleShowDeleteModal = (record) => {
        setSelectedRecord(record);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedRecord(null);
    };

    const handleRemoveFarm = async () => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }

        setShowPreloader(true);
        try {
            if (!selectedRecord) {
                console.error('No selected Record');
                return;
            }

            const requestOptions = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                },
                redirect: "follow",
            };

            const response = await fetch(`${baseURL}/farms/${selectedRecord.id}`, requestOptions);
            if (response.ok) {
                toast.success("Farm Record removed successfully");
                handleCloseDeleteModal();
                setShowPreloader(true);
                window.location.reload();
            } else {
                handleNotOkHttpResponse(response);
                return false;
            }
        } catch (error) {
            console.error("Error on removing Farm Record:", error.message);
        } finally {
            setShowPreloader(false);
        }
    };


    return (
        <>
            <Preloader show={showPreloader} />
            <div className="main-container">
                <div className="row gutters">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="card-title">List of Farms</div>
                                <div className="mt-3 p-2 parentLabel">
                                    <div className="mt-2 mb-1">
                                        <span>Farmer: </span>{getFarmerFullName(farmer)}
                                    </div>
                                </div>
                                <br />
                                <Link
                                    to={`/farm/create/?farmer=${farmerId}`}
                                    className="btn btn-primary float-end"
                                >
                                    <i className="icon-add"></i> Add Farm
                                </Link>
                            </div>
                            <div className="card-body pt-0">
                                <div className="row gutters">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="table-responsive">
                                            <table id="data-table" className="table custom-table">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>Code</th>
                                                        <th>GLN</th>
                                                        <th>Farm Name</th>
                                                        <th>Farm Area <em>{'(' + getFarmAreaUnit() + ')'}</em></th>
                                                        <th>Location</th>
                                                        <th>Date Established</th>
                                                        <th><div className="float-end">Actions</div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {farms && farms.length > 0 ? farms.map((farm, index) => (
                                                        <tr key={index}>
                                                            <td>{farm.farmCode ? farm.farmCode : '--'}</td>
                                                            <td>{farm.gln ? farm.gln : '--'}</td>
                                                            <td>{farm.name}</td>
                                                            <td>{farm.area}</td>
                                                            <td>{farm.location}</td>
                                                            <td>{isoToDate(farm.dateEstablished)}</td>
                                                            <td className="">
                                                                <ul>
                                                                    <li className="user_setting float-end" style={{ listStyle: "none" }}>
                                                                        <div className="dropdown">
                                                                            <Link
                                                                                className="btn btn-secondary dropdown-toggle dn-1199 ms-2"
                                                                                role="button"
                                                                                to="#"
                                                                                id={"dropdownMenuLink" + farm.id}
                                                                                data-bs-toggle="dropdown"
                                                                            >
                                                                                Actions <i className="fa fa-caret-down"></i>
                                                                            </Link>
                                                                            <ul
                                                                                className="dropdown-menu"
                                                                                aria-labelledby={"dropdownMenuLink" + farm.id}
                                                                            >
                                                                                {profileMenuItems.map((actionMenuItem) => (
                                                                                    <li key={farm.id + '-' + actionMenuItem.id}>
                                                                                        {actionMenuItem.onClick ? (
                                                                                            <Link
                                                                                                to="#"
                                                                                                className="dropdown-item"
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault(); // Prevent default anchor behavior
                                                                                                    actionMenuItem.onClick(farm);
                                                                                                }}
                                                                                                style={
                                                                                                    isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                        ? { color: "#ff5a5f" }
                                                                                                        : undefined
                                                                                                }
                                                                                            >
                                                                                                <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                            </Link>
                                                                                        ) : (
                                                                                            <Link
                                                                                                to={actionMenuItem.routerPath + "/" + farm.id} // Changed href to to
                                                                                                className="dropdown-item"
                                                                                                style={
                                                                                                    isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                        ? { color: "#ff5a5f" }
                                                                                                        : undefined
                                                                                                }
                                                                                            >
                                                                                                <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                            </Link>
                                                                                        )}
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    )) : (<tr><td colSpan="7" className="text-center"><em>No data available!</em></td></tr>)}
                                                </tbody>
                                            </table>
                                            {/* Delete Modal */}
                                            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                                                <Modal.Header closeButton style={{ backgroundColor: 'rgb(36, 50, 74)' }}>
                                                    <Modal.Title style={{ color: 'white' }}>Delete Farm Record</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <p className="mb-4">
                                                        Are you sure you want to delete this farm record?
                                                    </p>
                                                </Modal.Body>
                                                <Modal.Footer style={{ borderTop: 'none' }}>
                                                    <Button variant="secondary" style={{ color: '#fff', backgroundColor: '#6c757d', border: 'none' }} onClick={handleCloseDeleteModal}>
                                                        Cancel
                                                    </Button>
                                                    <Button variant="danger" style={{ color: '#fff', backgroundColor: '#dc3545', border: 'none' }} onClick={handleRemoveFarm}>
                                                        Delete
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal>

                                            {/* View Modal */}
                                            <Modal size="lg" show={showViewModal} onHide={handleCloseViewModal}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Farm Record Details</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    {selectedRecord ? (
                                                        <div className="formView">
                                                            <p><strong>Code:</strong> {selectedRecord.farmCode ? selectedRecord.farmCode : "N/A"}</p>
                                                            <p><strong>Name:</strong> {selectedRecord.name}</p>
                                                            <p><strong>Location:</strong> {selectedRecord.location}</p>
                                                            <p><strong>Area:</strong> {selectedRecord.area}{runningCompanyId === CompanyIds.TropighaFarmsLtd ? ' hectors' : ' acres'}</p>
                                                            <p><strong>Date Established:</strong> {isoToDate(selectedRecord.dateEstablished)}</p>
                                                        </div>
                                                    ) : (
                                                        <p>No record selected.</p>
                                                    )}

                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="secondary" onClick={handleCloseViewModal}>
                                                        Close
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Row start */}
                {/* Row end */}
            </div>

        </>
    );
}

export default FarmTable;